import OptionConfiguration from './OptionConfiguration'

import './style.scss'

export { OptionConfiguration }
export default OptionConfiguration
